export default "__VITE_ASSET__fci6E7Ox__"